// extracted by mini-css-extract-plugin
export default {"container":"Counter_container__K9+0-","heading":"Counter_heading__thUo4","counterValue":"Counter_counterValue__tsRTf","cnt":"Counter_cnt__SUL2U"};